import { useRequest } from "./use-request";

export const useGet = (target = "", config = {}) =>
  useRequest({
    ...config,
    url: target,
    lazy: target ? config?.lazy : true,
    stateless: config?.stateless ?? false
  });
